<template>
  <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <div>
          <h3>智能插座配置</h3>
          <p class="device-subtitle">{{ deviceData?.deviceName || '-' }}</p>
        </div>
        <button @click="handleClose" class="close-btn">&times;</button>
      </div>

      <div class="modal-body">
        <form class="device-form" @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="mqttHost" class="required">MQTT地址</label>
            <input id="mqttHost" v-model="formData.mqttHost" type="text" class="form-input" placeholder="如 mqtt.smart-bird.cn" :class="{ error: errors.mqttHost }" />
            <span v-if="errors.mqttHost" class="error-message">{{ errors.mqttHost }}</span>
          </div>

          <div class="form-group">
            <label for="mqttPort" class="required">MQTT端口</label>
            <input id="mqttPort" v-model.number="formData.mqttPort" type="number" min="1" class="form-input" placeholder="如 1883" :class="{ error: errors.mqttPort }" />
            <span v-if="errors.mqttPort" class="error-message">{{ errors.mqttPort }}</span>
          </div>

          <div class="form-group">
            <label for="mqttClientId" class="required">Client ID（开发设置调试）</label>
            <input id="mqttClientId" v-model="formData.mqttClientId" type="text" class="form-input" placeholder="请输入控制台开发设置里的 Client ID" :class="{ error: errors.mqttClientId }" />
            <span v-if="errors.mqttClientId" class="error-message">{{ errors.mqttClientId }}</span>
          </div>

          <div class="form-group">
            <label for="mqttUsername" class="required">用户名</label>
            <input id="mqttUsername" v-model="formData.mqttUsername" type="text" class="form-input" placeholder="请输入控制台开发设置里的用户名" :class="{ error: errors.mqttUsername }" />
            <span v-if="errors.mqttUsername" class="error-message">{{ errors.mqttUsername }}</span>
          </div>

          <div class="form-group">
            <label for="mqttPassword" class="required">密码</label>
            <input id="mqttPassword" v-model="formData.mqttPassword" type="text" class="form-input" placeholder="请输入控制台开发设置里的密码" :class="{ error: errors.mqttPassword }" />
            <span v-if="errors.mqttPassword" class="error-message">{{ errors.mqttPassword }}</span>
          </div>

          <div class="form-group">
            <label for="deviceIdentifier" class="required">设备标识（客户ID）</label>
            <input id="deviceIdentifier" v-model="formData.deviceIdentifier" type="text" class="form-input" placeholder="请输入设备管理弹窗里的客户ID" :class="{ error: errors.deviceIdentifier }" />
            <span v-if="errors.deviceIdentifier" class="error-message">{{ errors.deviceIdentifier }}</span>
          </div>

          <div class="form-group">
            <label for="topicDevicePublish" class="required">上行主题（设备上报，客户端订阅）</label>
            <input id="topicDevicePublish" v-model="formData.topicDevicePublish" type="text" class="form-input" placeholder="如 /xxx/.../publish" :class="{ error: errors.topicDevicePublish }" />
            <span v-if="errors.topicDevicePublish" class="error-message">{{ errors.topicDevicePublish }}</span>
          </div>

          <div class="form-group">
            <label for="topicDeviceSubscribe" class="required">下行主题（控制指令，客户端发布）</label>
            <input id="topicDeviceSubscribe" v-model="formData.topicDeviceSubscribe" type="text" class="form-input" placeholder="如 /xxx/.../subscribe" :class="{ error: errors.topicDeviceSubscribe }" />
            <span v-if="errors.topicDeviceSubscribe" class="error-message">{{ errors.topicDeviceSubscribe }}</span>
          </div>

          <div class="form-group">
            <label for="smartPlugCycleEnabled">空闲循环断电</label>
            <select id="smartPlugCycleEnabled" v-model="formData.smartPlugCycleEnabled" class="form-select">
              <option :value="false">关闭</option>
              <option :value="true">开启</option>
            </select>
          </div>

          <div class="form-group" v-if="formData.smartPlugCycleEnabled">
            <label for="smartPlugCycleIntervalMinutes" class="required">每隔多少分钟断电一次</label>
            <input id="smartPlugCycleIntervalMinutes" v-model.number="formData.smartPlugCycleIntervalMinutes" type="number" min="1" class="form-input" placeholder="请输入分钟数" :class="{ error: errors.smartPlugCycleIntervalMinutes }" />
            <span v-if="errors.smartPlugCycleIntervalMinutes" class="error-message">{{ errors.smartPlugCycleIntervalMinutes }}</span>
          </div>

          <div class="form-group" v-if="formData.smartPlugCycleEnabled">
            <label for="smartPlugPowerOffSeconds" class="required">断电后多少秒恢复通电</label>
            <input id="smartPlugPowerOffSeconds" v-model.number="formData.smartPlugPowerOffSeconds" type="number" min="1" class="form-input" placeholder="请输入秒数" :class="{ error: errors.smartPlugPowerOffSeconds }" />
            <span v-if="errors.smartPlugPowerOffSeconds" class="error-message">{{ errors.smartPlugPowerOffSeconds }}</span>
          </div>
        </form>

        <div class="test-section">
          <div class="test-title">连接测试</div>
          <div class="test-actions">
            <button class="test-btn power-off-btn" :disabled="loading || testingAction === 'power_off'" @click="handleTest('power_off')">
              {{ testingAction === 'power_off' ? '断电中...' : '测试断电' }}
            </button>
            <button class="test-btn power-on-btn" :disabled="loading || testingAction === 'power_on'" @click="handleTest('power_on')">
              {{ testingAction === 'power_on' ? '通电中...' : '测试通电' }}
            </button>
          </div>
          <p v-if="testMessage" :class="['test-message', testSuccess ? 'success' : 'error']">{{ testMessage }}</p>
        </div>
      </div>

      <div class="modal-footer">
        <button @click="handleClose" class="cancel-btn">取消</button>
        <button @click="handleSubmit" class="submit-btn" :disabled="loading">
          {{ loading ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'EditSocketConfigModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deviceData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'success'],
  data() {
    return {
      loading: false,
      testingAction: '',
      testMessage: '',
      testSuccess: false,
      errors: {},
      formData: {
        mqttHost: '',
        mqttPort: 1883,
        mqttClientId: '',
        mqttUsername: '',
        mqttPassword: '',
        deviceIdentifier: '',
        topicDevicePublish: '',
        topicDeviceSubscribe: '',
        smartPlugCycleEnabled: false,
        smartPlugCycleIntervalMinutes: 30,
        smartPlugPowerOffSeconds: 10
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
      }
    },
    deviceData: {
      deep: true,
      handler() {
        if (this.visible) {
          this.initFormData()
        }
      }
    }
  },
  methods: {
    initFormData() {
      this.formData = {
        mqttHost: this.deviceData?.mqttHost || '',
        mqttPort: this.deviceData?.mqttPort || 1883,
        mqttClientId: this.deviceData?.mqttClientId || '',
        mqttUsername: this.deviceData?.mqttUsername || '',
        mqttPassword: this.deviceData?.mqttPassword || '',
        deviceIdentifier: this.deviceData?.deviceIdentifier || '',
        topicDevicePublish: this.deviceData?.topicDevicePublish || '',
        topicDeviceSubscribe: this.deviceData?.topicDeviceSubscribe || '',
        smartPlugCycleEnabled: Boolean(this.deviceData?.smartPlugCycleEnabled),
        smartPlugCycleIntervalMinutes: this.deviceData?.smartPlugCycleIntervalMinutes || 30,
        smartPlugPowerOffSeconds: this.deviceData?.smartPlugPowerOffSeconds || 10
      }
      this.errors = {}
      this.testingAction = ''
      this.testMessage = ''
      this.testSuccess = false
      this.loading = false
    },
    validateForm() {
      this.errors = {}
      let isValid = true
      const requiredFields = [
        ['mqttHost', '请输入 MQTT 地址'],
        ['mqttPort', '请输入正确的 MQTT 端口'],
        ['mqttClientId', '请输入 Client ID'],
        ['mqttUsername', '请输入用户名'],
        ['mqttPassword', '请输入密码'],
        ['deviceIdentifier', '请输入设备标识'],
        ['topicDevicePublish', '请输入上行主题'],
        ['topicDeviceSubscribe', '请输入下行主题']
      ]

      requiredFields.forEach(([field, message]) => {
        const value = this.formData[field]
        if (field === 'mqttPort') {
          if (!value || Number(value) <= 0) {
            this.errors[field] = message
            isValid = false
          }
        } else if (!value || !String(value).trim()) {
          this.errors[field] = message
          isValid = false
        }
      })

      if (this.formData.smartPlugCycleEnabled) {
        if (!this.formData.smartPlugCycleIntervalMinutes || this.formData.smartPlugCycleIntervalMinutes <= 0) {
          this.errors.smartPlugCycleIntervalMinutes = '请输入大于 0 的循环间隔'
          isValid = false
        }
        if (!this.formData.smartPlugPowerOffSeconds || this.formData.smartPlugPowerOffSeconds <= 0) {
          this.errors.smartPlugPowerOffSeconds = '请输入大于 0 的恢复秒数'
          isValid = false
        }
      }

      return isValid
    },
    buildPayload() {
      return {
        mqttHost: this.formData.mqttHost.trim(),
        mqttPort: Number(this.formData.mqttPort),
        mqttClientId: this.formData.mqttClientId.trim(),
        mqttUsername: this.formData.mqttUsername.trim(),
        mqttPassword: this.formData.mqttPassword.trim(),
        deviceIdentifier: this.formData.deviceIdentifier.trim(),
        topicDevicePublish: this.formData.topicDevicePublish.trim(),
        topicDeviceSubscribe: this.formData.topicDeviceSubscribe.trim(),
        smartPlugCycleEnabled: this.formData.smartPlugCycleEnabled,
        smartPlugCycleIntervalMinutes: this.formData.smartPlugCycleEnabled
          ? Number(this.formData.smartPlugCycleIntervalMinutes)
          : null,
        smartPlugPowerOffSeconds: this.formData.smartPlugCycleEnabled
          ? Number(this.formData.smartPlugPowerOffSeconds)
          : null
      }
    },
    async handleSubmit() {
      if (!this.validateForm()) return
      this.loading = true
      try {
        const response = await request.put(`/api/devices/${this.deviceData.id}/socket-config`, this.buildPayload())
        if (response.data.success && response.data.code === 200) {
          this.$emit('success', response.data.data)
          this.handleClose()
          return
        }
        throw new Error(response.data.message || '保存配置失败')
      } catch (error) {
        alert(error.response?.data?.message || error.message || '保存配置失败')
      } finally {
        this.loading = false
      }
    },
    async handleTest(action) {
      if (!this.validateForm()) return
      this.testingAction = action
      this.testMessage = ''
      this.testSuccess = false
      try {
        await request.put(`/api/devices/${this.deviceData.id}/socket-config`, this.buildPayload())
        const response = await request.post(`/api/devices/${this.deviceData.id}/socket-control`, { action })
        if (response.data.success && response.data.code === 200) {
          this.testSuccess = Boolean(response.data.data?.success)
          this.testMessage = this.testSuccess
            ? `${action === 'power_on' ? '通电' : '断电'}指令已发送`
            : `${action === 'power_on' ? '通电' : '断电'}指令发送失败`
          this.$emit('success', { ...this.deviceData, ...this.buildPayload() })
          return
        }
        throw new Error(response.data.message || '测试失败')
      } catch (error) {
        this.testSuccess = false
        this.testMessage = error.response?.data?.message || error.message || '测试失败'
      } finally {
        this.testingAction = ''
      }
    },
    handleClose() {
      this.$emit('close')
    },
    handleOverlayClick() {
      if (!this.loading && !this.testingAction) {
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 640px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0 0 4px 0;
  font-size: 18px;
  color: #333;
}

.device-subtitle {
  margin: 0;
  font-size: 13px;
  color: #999;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.modal-body {
  padding: 24px;
  max-height: 68vh;
  overflow-y: auto;
}

.device-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group label.required::after {
  content: ' *';
  color: #ff4d4f;
}

.form-input,
.form-select {
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-input.error,
.form-select.error {
  border-color: #ff4d4f;
}

.error-message {
  color: #ff4d4f;
  font-size: 12px;
}

.test-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.test-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.test-actions {
  display: flex;
  gap: 12px;
}

.test-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
}

.power-off-btn {
  background: #ff4d4f;
}

.power-on-btn {
  background: #52c41a;
}

.test-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.test-message {
  margin: 12px 0 0;
  font-size: 13px;
}

.test-message.success {
  color: #52c41a;
}

.test-message.error {
  color: #ff4d4f;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.cancel-btn,
.submit-btn {
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  border: 1px solid #d9d9d9;
  background: white;
  color: #666;
}

.submit-btn {
  border: 1px solid #1890ff;
  background: #1890ff;
  color: white;
}

.submit-btn:disabled {
  background: #d9d9d9;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .modal-container {
    width: 95%;
  }

  .test-actions,
  .modal-footer {
    flex-direction: column;
  }
}
</style>
